import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const TooltipMeta: ComponentMeta = {
  componentName: "Tooltip",
  package: "@mijadesign/web",
  title: "文字提示",
  description: "简单的文字提示",
  category: ComponentCategory.FEEDBACK,
  icon: "QuestionCircleOutlined",
  canHaveChildren: true,
  props: [
    {
      name: "title",
      label: "提示内容",
      type: PropType.STRING,
      group: "基础",
    },
  ],
  defaultProps: {
    title: "提示文字",
  },
  npm: {
    package: "@mijadesign/web",
    exportName: "Tooltip",
  },
  snippet: {
    componentName: "Tooltip",
    package: "@mijadesign/web",
    props: { title: "提示文字" },
  },
};

export const PopconfirmMeta: ComponentMeta = {
  componentName: "Popconfirm",
  package: "@mijadesign/web",
  title: "气泡确认框",
  description: "带有确认和取消按钮的弹出提示",
  category: ComponentCategory.FEEDBACK,
  icon: "QuestionCircleOutlined",
  canHaveChildren: true,
  props: [
    {
      name: "title",
      label: "确认标题",
      type: PropType.STRING,
      group: "基础",
    },
    {
      name: "okText",
      label: "确认文字",
      type: PropType.STRING,
      defaultValue: "确定",
      group: "文本",
    },
    {
      name: "cancelText",
      label: "取消文字",
      type: PropType.STRING,
      defaultValue: "取消",
      group: "文本",
    },
  ],
  defaultProps: {
    title: "确认删除？",
    okText: "确定",
    cancelText: "取消",
  },
  npm: {
    package: "@mijadesign/web",
    exportName: "Popconfirm",
  },
  snippet: {
    componentName: "Popconfirm",
    package: "@mijadesign/web",
    props: { title: "确认删除？" },
  },
};

export const SkeletonMeta: ComponentMeta = {
  componentName: "Skeleton",
  package: "@mijadesign/web",
  title: "骨架屏",
  description: "内容加载时的占位骨架",
  category: ComponentCategory.FEEDBACK,
  icon: "ScissorOutlined",
  canHaveChildren: false,
  props: [
    {
      name: "active",
      label: "动画",
      type: PropType.BOOLEAN,
      defaultValue: true,
      group: "样式",
    },
    {
      name: "avatar",
      label: "显示头像",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "内容",
    },
    {
      name: "title",
      label: "显示标题",
      type: PropType.BOOLEAN,
      defaultValue: true,
      group: "内容",
    },
    {
      name: "paragraph",
      label: "显示段落",
      type: PropType.BOOLEAN,
      defaultValue: true,
      group: "内容",
    },
  ],
  defaultProps: {
    active: true,
    title: true,
    paragraph: true,
  },
  npm: {
    package: "@mijadesign/web",
    exportName: "Skeleton",
  },
  snippet: {
    componentName: "Skeleton",
    package: "@mijadesign/web",
    props: {},
  },
};
